// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__ZSgZ7","active":"NavigationItem_active__Szt5f"};